export const TABS = ['boxes', 'locations', 'counts'];

export function parseTab(search) {
  const t = new URLSearchParams(search || '').get('tab');
  return TABS.includes(t) ? t : 'boxes';
}

export function statusTone(status) {
  return { printed: 'attention', assigned: 'info', shelved: 'success' }[status];
}

export function fmtAgo(iso, now = Date.now()) {
  if (!iso) return '—';
  const s = Math.max(0, (now - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  const m = s / 60;
  if (m < 60) return `${Math.floor(m)}m ago`;
  const h = m / 60;
  if (h < 48) return `${Math.floor(h)}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export function newOpId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}

export function pickWarehouse(warehouses, savedId) {
  const ws = warehouses || [];
  if (!ws.length) return null;
  const hit = ws.find(w => String(w.shopify_location_id) === String(savedId));
  if (hit) return hit;
  return ws.length === 1 ? ws[0] : null;
}

export function variantLabel(v) {
  const opts = (v?.selected_options || [])
    .map(o => o.value)
    .filter(val => val && val !== 'Default Title');
  return opts.length ? opts.join(' / ') : (v?.sku || '');
}

export function boxesQuery({ status, locationId, q } = {}) {
  // Not URLSearchParams: it encodes spaces as "+", but the query hits FastAPI
  // via authFetch's raw fetch(), so we need %20-style percent-encoding.
  const parts = [];
  if (status) parts.push(`status=${encodeURIComponent(status)}`);
  if (locationId) parts.push(`location_id=${encodeURIComponent(locationId)}`);
  if (q && q.trim()) parts.push(`q=${encodeURIComponent(q.trim())}`);
  return parts.join('&');
}
